/**
 * ATTENTION!!!
 * THIS FILE IS AUTOMATICALLY GENERATED BY WEBPACK BUILD SCRIPT
 * DO NOT CHANGE IT MANUALLY
 * ALL CHANGES WILL BE OVERWRITTEN
 * eslint-disable
 */
// static import to make sure everything is bound correctly
import * as defaultStrings from './en_US';
export {defaultStrings};
export const loader = async locale => {
    if (locale === 'zh_TW') return await import(/* webpackChunkName:'zh_TW' */ './zh_TW');
    if (locale === 'zh_HK') return await import(/* webpackChunkName:'zh_HK' */ './zh_HK');
    if (locale === 'zh_CN') return await import(/* webpackChunkName:'zh_CN' */ './zh_CN');
    if (locale === 'sv_SE') return await import(/* webpackChunkName:'sv_SE' */ './sv_SE');
    if (locale === 'rc_XX') return await import(/* webpackChunkName:'rc_XX' */ './rc_XX');
    if (locale === 'pt_PT') return await import(/* webpackChunkName:'pt_PT' */ './pt_PT');
    if (locale === 'pt_BR') return await import(/* webpackChunkName:'pt_BR' */ './pt_BR');
    if (locale === 'pl_PL') return await import(/* webpackChunkName:'pl_PL' */ './pl_PL');
    if (locale === 'nl_NL') return await import(/* webpackChunkName:'nl_NL' */ './nl_NL');
    if (locale === 'ko_KR') return await import(/* webpackChunkName:'ko_KR' */ './ko_KR');
    if (locale === 'ja_JP') return await import(/* webpackChunkName:'ja_JP' */ './ja_JP');
    if (locale === 'it_IT') return await import(/* webpackChunkName:'it_IT' */ './it_IT');
    if (locale === 'fr_FR') return await import(/* webpackChunkName:'fr_FR' */ './fr_FR');
    if (locale === 'fr_CA') return await import(/* webpackChunkName:'fr_CA' */ './fr_CA');
    if (locale === 'fi_FI') return await import(/* webpackChunkName:'fi_FI' */ './fi_FI');
    if (locale === 'es_ES') return await import(/* webpackChunkName:'es_ES' */ './es_ES');
    if (locale === 'es_419') return await import(/* webpackChunkName:'es_419' */ './es_419');
    if (locale === 'en_ZZ') return await import(/* webpackChunkName:'en_ZZ' */ './en_ZZ');
    if (locale === 'en_GB') return await import(/* webpackChunkName:'en_GB' */ './en_GB');
    if (locale === 'en_CA') return await import(/* webpackChunkName:'en_CA' */ './en_CA');
    if (locale === 'en_AU') return await import(/* webpackChunkName:'en_AU' */ './en_AU');
    if (locale === 'de_DE') return await import(/* webpackChunkName:'de_DE' */ './de_DE');
    return null; // loader must return null for default (en_US) locale
};


/** @returns {Array<String>} */
export const getSupportedLocales = () => [
    'en_US',
    'zh_TW',
    'zh_HK',
    'zh_CN',
    'sv_SE',
    'rc_XX',
    'pt_PT',
    'pt_BR',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP',
    'it_IT',
    'fr_FR',
    'fr_CA',
    'fi_FI',
    'es_ES',
    'es_419',
    'en_ZZ',
    'en_GB',
    'en_CA',
    'en_AU',
    'de_DE'
];